export interface PaysafeSelectorStyle {
  'font-family'?: string;
  'font-size'?: string;
  'font-style'?: string;
  'font-weight'?: string;
  'letter-spacing'?: string;
  'line-height'?: string;
  'text-align'?: string;
  'text-decoration'?: string;
  'text-indent'?: string;
  'text-shadow'?: string;
  color?: string;
  font?: string;
  opacity?: string;
  transition?: string;
}
